import React from 'react';
import { Switch, FormControlLabel, Box } from '@material-ui/core';
import { useTemperature } from './temperatureContext';

interface TemperatureToggleProps {
  currentPage?: string;
  hiddenOnPages?: string[];
}

export const TemperatureToggle: React.FC<TemperatureToggleProps> = ({ 
  hiddenOnPages = [], 
  currentPage 
}) => {
  const { unit, toggleUnit } = useTemperature();

  // Check if the switch should be hidden on the current page
  if (
    !toggleUnit || 
    (currentPage && hiddenOnPages.includes(currentPage))
  ) {
    return null;
  }

  return (
    <Box ml={2} mt={0.4}>
      <FormControlLabel
        control={
          <Switch
            checked={unit === 'F'}
            onChange={toggleUnit}
            color="primary"
          />
        }
        label={`°${unit === 'C' ? 'C' : 'F'}`}
      />
    </Box>
  );
};